import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { toggleSidebar } from '../../../redux/sidebar/sidebarReducer';
import BurgerIcon from '../../../components/burger-icon/BurgerIcon';

import scss from './BurgerMenuIcon.module.scss';

function BurgerMenuIcon() {
  const dispatch = useDispatch();
  const { t } = useTranslation('sidebar');

  const slimSidebar = useSelector((state) => state.sidebar.slim);
  const isOpen = !slimSidebar;

  const handleToggleMenu = () => {
    dispatch(toggleSidebar());
  };

  return (
    <div className={scss.burgerMenuWrapper}>
      <BurgerIcon isOpen={isOpen} onChange={handleToggleMenu} aria-label={isOpen ? t('closeMenu') : t('openMenu')} />
    </div>
  );
}

export default BurgerMenuIcon;
